import { render } from "./FulfilmentRing.vue?vue&type=template&id=2439fa29"
import script from "./FulfilmentRing.vue?vue&type=script&lang=js"
export * from "./FulfilmentRing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__